import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoPatientSalesOrderTemplate } from "themes/application/niko-patient-sales-order/pages";
import { NikoPatientSalesOrderViewStore } from "../stores";

@setCurrentView(rootStore => new NikoPatientSalesOrderViewStore(rootStore), "nikoPatientSalesOrderViewStore")
@observer
class NikoPatientSalesOrder extends React.Component {
	render() {
		return <NikoPatientSalesOrderTemplate {...this.props} />;
	}
}

export default NikoPatientSalesOrder;